import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';

const packageInfo = require('../../../../../../package.json');
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})

export class FooterComponent implements OnInit {
  appConfig = AppConfig;
  packageInfo = packageInfo;

  versionLabel: string = "";

  constructor(private trsService: TrsEventsService, private translationService: TranslocoService) { }

  ngOnInit(): void {
    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS":
          this.versionLabel = this.translationService.translate("Version");
          break;
      }
    });
  }
}
